import request from '../../utils/request'

const getParticulars = (template,mark,modify) => {
    return request({
        url: process.env.VUE_APP_API + `particulars/activity/${template}/${mark}/${modify}`,
        method: 'GET',
    })
}
export {
  getParticulars
}